import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles, useTheme } from '@material-ui/core/styles';
import ArticleList from '../../main/article-list';
import useMediaQuery from '@material-ui/core/useMediaQuery';


function ArticleListDialog(props) {
  const { classes, onClose, visibleArticles, printArticleList, isEPosPrinterEnabled } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const articlemap = new Map();

  visibleArticles.forEach(order =>
    order.articles.forEach((article) => {
      const articlefeatures = article.features ? article.features.join(', ') : null;
      const articlenNameWithFeatures = article.name + articlefeatures;

      let currentValue = articlemap.get(articlenNameWithFeatures);


      if (typeof currentValue === 'undefined') {
        currentValue = { name: article.name, features: article.features, quantity: 0 };
      }

      currentValue.quantity += article.quantity;


      articlemap.set(articlenNameWithFeatures, currentValue);
    }),
  );

  const articles = [];

  for (const article of articlemap.values()) {
    articles.push({
      name: article.name,
      quantity: article.quantity,
      features: article.features,
    });
  }

  const printButton = (
    <Button
      color="primary"
      className={classes.button}
      onClick={() => printArticleList(articles)}
    >
      Drucken
    </Button>
  );

  const backButton = (
    <Button
      color="primary"
      className={classes.button}
      onClick={onClose}
    >
      Zurück
    </Button>
  );

  return (
    <Dialog
      fullScreen={fullScreen}
      classes={{ paper: 'printDialog' }}
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Artikelliste</DialogTitle>

      <DialogContent>
        <ArticleList
          value={articles}
        />
      </DialogContent>
      <DialogActions>
        {isEPosPrinterEnabled ? printButton : null}
        {backButton}
      </DialogActions>
    </Dialog>
  );
}


const styles = theme => ({
});


ArticleListDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  visibleArticles: PropTypes.array.isRequired,
  printArticleList: PropTypes.func.isRequired,
  isEPosPrinterEnabled: PropTypes.bool.isRequired,
};

ArticleListDialog.defaultProps = {
};


export default withStyles(styles)(ArticleListDialog);

